import axios from "axios";
import { authorizationHeaders } from "../../../common/apis/auth";
import { Urls } from "../../../common/apis/urls";
import { FriendModel } from "../models/friend.model";
import { GetFriendshipsResult, toModel } from "./contracts/get-friendships.result";

export async function fetchFriends(): Promise<FriendModel[]> {
    const { data } = await axios.get<GetFriendshipsResult>(Urls.map.getFriendships(), authorizationHeaders());
    return toModel(data);
}